import {
  Badge,
  Box,
  Button,
  ComboboxItem,
  Flex,
  Grid,
  Select,
} from "@mantine/core";
import { useDebouncedValue, useIsFirstRender } from "@mantine/hooks";
import {
  IconBarcode,
  IconBrandBootstrap,
  IconBuildingWarehouse,
  IconSearch,
} from "@tabler/icons-react";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_RowSelectionState,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useEffect, useState } from "react";
import {
  keySearchCompareInventory,
  repositoryMdm,
  repositoryPos,
} from "../../../_base/_const/_constVar";
import _breadcrumb from "../../../_base/component/_layout/_breadcrumb";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { changeSearchValue } from "../../../_base/helper/FunctionHelper";
import { _localization } from "../../../config/location";
import { green } from "../../../const/variables";
import { MessageResponse } from "../../../model/MessageResponse";
import { getMasterOrgSelect } from "../../../service/getSelectApi";

const CompareInventory = () => {
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [data1, setData1] = useState<any[]>([]);
  const [dataList1, setDataList1] = useState<any[]>([]);
  const [data2, setData2] = useState<any[]>([]);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount1, setRowCount1] = useState(0);
  const [rowCount2, setRowCount2] = useState(0);
  const [height, setHeight] = useState(0);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [loadingSync, setLoadingSync] = useState<boolean>(false);
  const [pagination1, setPagination1] = useState({
    pageIndex: 0,
    pageSize: 100,
  });

  const [pagination2, setPagination2] = useState({
    pageIndex: 0,
    pageSize: 100,
  });

  const [dataBranchSelect, setDataBranchSelect] = useState<ComboboxItem[]>([]);
  const [dataInvSelect, setDataInvSelect] = useState<ComboboxItem[]>([]);
  const [searchMaVt, setSearchMaVt] = useState<string>("");
  const [debounceSearchMaVt] = useDebouncedValue(searchMaVt, 500);
  const [dataMaVt, setDataMaVt] = useState<ComboboxItem[]>([]);

  const firstRender = useIsFirstRender();
  const checkedPinSearch = localStorage.getItem("checkedPinSearch") === "true";
  const _searchJson = (() => {
    try {
      const storedValue = sessionStorage.getItem(keySearchCompareInventory);
      return storedValue ? JSON.parse(storedValue) : null;
    } catch (error) {
      console.error("Lỗi khi parse JSON từ sessionStorage:", error);
      return null;
    }
  })();

  const [search, setSearch] = useState({
    MaKho:
      firstRender && _searchJson && checkedPinSearch ? _searchJson.MaKho : "",
    MaCn:
      firstRender && _searchJson && checkedPinSearch ? _searchJson.MaCn : "",
    MaVt:
      firstRender && _searchJson && checkedPinSearch ? _searchJson.MaVt : "",
  });

  const columns1 = React.useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        accessorKey: "STT",
        header: "STT",
        enableColumnActions: false,
        enableSorting: false,
        enableResizing: false,
        enableColumnFilter: false,
        Cell: ({ row }) => <>{row?.index + 1}</>,
      },
      {
        accessorKey: "K",
        header: "Mã phiếu",
        Cell: ({ renderedCellValue, row }) => (
          <Badge
            radius="sm"
            variant="dot"
            size="lg"
            style={{ cursor: "pointer" }}
            color={renderedCellValue === null ? "red" : green.base}
          >
            {renderedCellValue === null ? null : renderedCellValue}
          </Badge>
        ),
      },
    ],
    []
  );

  const columns2 = React.useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        accessorKey: "STT",
        header: "STT",
        enableColumnActions: false,
        enableSorting: false,
        enableResizing: false,
        enableColumnFilter: false,
        Cell: ({ row }) => <>{row?.index + 1}</>,
      },
      {
        accessorKey: "K",
        header: "Mã phiếu",
        Cell: ({ renderedCellValue, row }) => (
          <Badge
            radius="sm"
            variant="dot"
            size="lg"
            style={{ cursor: "pointer" }}
            color={renderedCellValue === null ? "red" : green.base}
          >
            {renderedCellValue === null ? null : renderedCellValue}
          </Badge>
        ),
      },
    ],
    []
  );

  const fetchData = async () => {
    if (search.MaVt && search.MaVt.length > 0) {
      setIsLoading(true);
      setIsRefetching(true);
      setIsError(false);

      const keySearchObj = {
        MaKho: search.MaKho,
        MaCn: search.MaCn,
        MaVt: search.MaVt,
      };

      try {
        let url = `/api/v1/CompareAsiaPos/so-sanh-kho-v2?type=1`;

        const params = new URLSearchParams();
        Object.entries(search).forEach(([key, value]) => {
          if (value.length > 0) {
            params.append(key, String(value));
          }
        });
        url += `&${params.toString()}&`;

        const res = await repositoryMdm.get<MessageResponse<any>>(url);

        if (res && res.success) {
          const result = res.data;
          setData1(result.map((item: any) => ({ K: item })));
          setRowCount1(res.totalCount);
          table1.resetRowSelection();
        }
      } catch (error) {
        setData1([]);
        setIsError(true);
        console.error(error);
        return;
      } finally {
        sessionStorage.setItem(
          keySearchCompareInventory,
          JSON.stringify(keySearchObj)
        );
        setIsLoading(false);
        setIsRefetching(false);
      }
    } else {
      NotificationExtension.Fails("Vui lòng chọn vật tư trước khi tìm kiếm !");
    }
  };

  const fetchDatav2 = async () => {
    setIsLoading(true);
    setIsRefetching(true);
    setIsError(false);

    const keySearchObj = {
      MaKho: search.MaKho,
      MaCn: search.MaCn,
      MaVt: search.MaVt,
    };

    try {
      let url = `/api/v1/CompareAsiaPos/so-sanh-kho-v2?type=2`;

      const params = new URLSearchParams();
      Object.entries(search).forEach(([key, value]) => {
        if (value.length > 0) {
          params.append(key, String(value));
        }
      });
      url += `&${params.toString()}`;

      const res = await repositoryMdm.get<MessageResponse<any>>(url);

      if (res && res.success) {
        const result = res.data;
        setData2(result.map((item: any) => ({ K: item })));
        setRowCount2(res.totalCount);
        table2.resetRowSelection();
      }
    } catch (error) {
      setData2([]);
      setIsError(true);
      console.error(error);
      return;
    } finally {
      sessionStorage.setItem(
        keySearchCompareInventory,
        JSON.stringify(keySearchObj)
      );
      setIsLoading(false);
      setIsRefetching(false);
    }
  };

  const fetchDataBranch = async () => {
    const res = await getMasterOrgSelect();

    if (res) {
      const data = res
        ?.filter((item) => item.text && item.value)
        ?.map((item) => ({
          label: `${item.att1} - ${item.text}`,
          value: item.value,
        }));
      setDataBranchSelect(data);
    }
  };

  const fetchDataInv = async () => {
    const MaCn = search.MaCn && search.MaCn.length > 0 ? search.MaCn : 0;

    const res = await repositoryPos.get<MessageResponse<any>>(
      `/api/v1/TblDmInventory/get-all?checkAuth=false&isAll=true&select=true&branchId=${MaCn}`
    );

    if (res && res.success) {
      const result = res.data
        ?.filter((item: any) => item.value !== "-1" && item.value && item.text)
        ?.map((item: any) => ({
          label: item.text?.toString(),
          value: item.value?.toString(),
        }));

      setDataInvSelect(result);
    }
  };

  const fetchDataMaVt = async () => {
    const res = await repositoryPos.get<MessageResponse<any>>(
      `/api/v1/TblItem/get-list?Skip=0&Take=20&KeySearch=${
        search.MaVt && search.MaVt.length > 0 ? search.MaVt : searchMaVt
      }`
    );

    if (res && res.success) {
      const result = res.data
        ?.filter((item: any) => item.itemCode && item.itemName)
        ?.map((item: any) => ({
          label: `${item.itemCode} - ${item.itemName}`,
          value: item.itemCode?.toString(),
        }));
      setDataMaVt(result);
    }
  };

  useEffect(() => {
    fetchDataInv();
  }, [search.MaCn]);

  useEffect(() => {
    if (debounceSearchMaVt.length > 3) {
      fetchDataMaVt();
    }
  }, [debounceSearchMaVt]);

  useEffect(() => {
    if (search.MaVt && search.MaVt.length > 0) {
      fetchData();
      fetchDatav2();
    }
  }, []);

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (260 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const table1 = useMantineReactTable({
    columns: columns1,
    data: data1,
    enableColumnResizing: false,
    positionToolbarAlertBanner: "bottom",
    //add custom action buttons to top-left of top toolbar
    renderTopToolbarCustomActions: ({ table }) => (
      <div
        ref={headerRef}
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Badge color="blue">
          Danh sách mã phiếu kho có trên POS mà không có trên ASIA
        </Badge>
      </div>
    ),
    renderToolbarInternalActions: ({ table }) => <></>,

    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    localization: _localization,
    enableRowSelection: false,
    getRowId: (row) => row.id,
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        left: ["mrt-row-select", "code"],
        right: ["action"],
      },
      columnVisibility: { id: true, phone: false, fax: false },
      density: "xs",
    },
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    onRowSelectionChange: setRowSelection,
    rowCount: rowCount1,
    onPaginationChange: setPagination1,
    mantineTableBodyCellProps: ({ row }) => ({
      style: {
        fontWeight: "normal", //conditional styling
        fontSize: "12.5px",
        padding: "5px 15px",
      },
    }),
    state: {
      isLoading,
      pagination: pagination1,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading, //loading for the first time with no data
      rowSelection,
    },
    mantineToolbarAlertBannerProps: isError
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: ["100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
    columnFilterDisplayMode: "popover",
    mantineTableBodyRowProps: ({ row }) => ({
      onClick: row.getToggleSelectedHandler(),
      sx: { cursor: "pointer" },
    }),
  });

  const table2 = useMantineReactTable({
    columns: columns2,
    data: data2,
    enableColumnResizing: false,
    positionToolbarAlertBanner: "bottom",
    //add custom action buttons to top-left of top toolbar
    renderTopToolbarCustomActions: ({ table }) => (
      <div
        ref={headerRef}
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Badge color="blue">
          Danh sách mã phiếu kho có trên ASIA mà không có trên POS
        </Badge>
      </div>
    ),
    renderToolbarInternalActions: ({ table }) => <></>,

    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    localization: _localization,
    enableRowSelection: false,
    getRowId: (row) => row.id,
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        left: ["mrt-row-select", "code"],
        right: ["action"],
      },
      columnVisibility: { id: true, phone: false, fax: false },
      density: "xs",
    },
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    onRowSelectionChange: setRowSelection,
    rowCount: rowCount2,
    onPaginationChange: setPagination2,
    mantineTableBodyCellProps: ({ row }) => ({
      style: {
        fontWeight: "normal", //conditional styling
        fontSize: "12.5px",
        padding: "5px 15px",
      },
    }),
    state: {
      isLoading,
      pagination: pagination2,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading, //loading for the first time with no data
      rowSelection,
    },
    mantineToolbarAlertBannerProps: isError
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: ["100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
    columnFilterDisplayMode: "popover",
    mantineTableBodyRowProps: ({ row }) => ({
      onClick: row.getToggleSelectedHandler(),
      sx: { cursor: "pointer" },
    }),
  });

  return (
    <Box w={"100%"}>
      <Flex
        w={"100%"}
        gap={"md"}
        wrap={"wrap"}
        justify={"space-between"}
        align={"center"}
      >
        <_breadcrumb></_breadcrumb>
      </Flex>
      <Grid w={"100%"}>
        <Grid.Col span={{ base: 12, md: 6, lg: 2.4 }}>
          <Select
            placeholder="Vật tư"
            data={dataMaVt}
            leftSection={<IconBarcode color="#15aabf" />}
            value={search.MaVt?.toString()}
            searchValue={searchMaVt}
            onSearchChange={setSearchMaVt}
            searchable
            clearable
            onClear={() => setDataMaVt([])}
            onChange={(e) => {
              changeSearchValue(e ? e : "", "MaVt", setSearch);
            }}
            nothingFoundMessage={
              debounceSearchMaVt &&
              debounceSearchMaVt.length > 3 &&
              dataMaVt.length === 0
                ? "Không tìm thấy dữ liệu !"
                : "Vui lòng nhập ít nhất 4 kí tự !"
            }
          />
        </Grid.Col>
        <Grid.Col span={{ base: 12, md: 6, lg: 2.4 }}>
          <Select
            placeholder="Chi nhánh"
            data={dataBranchSelect}
            leftSection={<IconBrandBootstrap color="#15aabf" />}
            searchable
            clearable
            value={search.MaCn?.toString()}
            onChange={(e) => changeSearchValue(e ? e : "", "MaCn", setSearch)}
            onClick={() => {
              if (dataBranchSelect.length === 0) {
                fetchDataBranch();
              }
            }}
            nothingFoundMessage="Không tìm thấy dữ liệu !"
          />
        </Grid.Col>
        <Grid.Col span={{ base: 12, md: 6, lg: 2.4 }}>
          <Select
            placeholder="Kho"
            data={dataInvSelect}
            leftSection={<IconBuildingWarehouse color="#15aabf" />}
            searchable
            clearable
            value={search.MaKho?.toString()}
            onChange={(e) => {
              changeSearchValue(e ? e : "", "MaKho", setSearch);
            }}
            nothingFoundMessage="Không tìm thấy dữ liệu !"
          />
        </Grid.Col>
        <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
          <Button
            leftSection={<IconSearch color="#15aabf" size={14} />}
            onClick={() => fetchData()}
          >
            Tìm kiếm
          </Button>
        </Grid.Col>
      </Grid>
      <Flex mt={5} w={"100%"} gap={"md"}>
        <Box w={"50%"}>
          <MantineReactTable table={table1} />
        </Box>
        <Box w={"50%"}>
          <MantineReactTable table={table2} />
        </Box>
      </Flex>
    </Box>
  );
};

export default CompareInventory;
